let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gEhfc")).then(() => parcelRequire('64wtY'));